import {
  type MRT_RowData,
  type MRT_TableOptions
} from "mantine-react-table-open";
import {
  getDefaultMRTOptions,
  type DefaultMRTOptionsOptions
} from "./getDefaultMRTOptions";

/** Define re-useable default options for a minimal Mantine-React-Table */
export function getMinimalMRTOptions<TData extends MRT_RowData>(
  options: DefaultMRTOptionsOptions<TData> = {}
): Partial<MRT_TableOptions<TData>> {
  return {
    ...getDefaultMRTOptions({
      hideBorder: true,
      ...options
    }),
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: false,
    enableTopToolbar: false,
    enableBottomToolbar: false
  };
}
